import React, { useEffect, useState } from "react";
import { HexColorPicker } from "react-colorful";
import { getUser, hasRole, setPage, toPrettyDate, useHub, validateRole } from "../../../core/Global";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { Link } from "react-router-dom";
import { DataTable, DataTableField } from "../../../components/data/DataTable";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import TextBox from "../../../components/form/TextBox";
import { toastSuccess } from "../../../components/base/Toast";
import { ColorModel } from "../models/ColorModel";
import { DrawerForm } from "../../../components/drawers/DrawerForm";

export default function ColorsListView() {

  const hub = useHub()
  const user = getUser()

  const [createModal, createModalSet] = useState<boolean>(false)
  const [editModal, editModalSet] = useState<boolean>(false)
  const [deleteModal, deleteModalSet] = useState<boolean>(false)
  const [deleteRes, deleteResSet] = useState<any>(true)

  const [selectedColor, selectedColorSet] = useState<string>()
  const [selectedItem, selectedItemSet] = useState<ColorModel>()

  useEffect(() => {
    selectedColorSet(selectedItem?.hexCode)
  }, [selectedItem])

  const [refresh, refreshSet] = useState<boolean>();

  const edit = (data: any) => {
    selectedItemSet(data);
    editModalSet(true);
  }

  const deleteColor = (data: any) => {
    selectedItemSet(data);
    deleteModalSet(true);
  }


  const NameItem = (data: ColorModel) => (
    <FlexRow onClick={() => edit(data)}>
      <div style={{
        width: 20,
        height: 20,
        backgroundColor: data.hexCode,
        border: "1px solid #000",
        borderRadius: 10
      }}>
      </div>
      <div className="ms-2">
        {data.name}
      </div>
      <a href="#" className="ms-1"
        onClick={e => {
          e.preventDefault();
          edit(data);
        }}>
        <Icon icon="edit" className="ms-2" size={12} />
      </a>
    </FlexRow>
  )


  const CreatedItem = (data: ColorModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }
    </div>
  )

  const ModifiedItem = (data: ColorModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.modifiedAt)}
      </div>
      {
        data.modifiedUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.modifiedUser.fullName}
          </div>
        </FlexRow>
      }
    </div>
  )

  useEffect(() => {

    validateRole("ManageColors");
    setPage("Colors", "Inventory", "Base Data");

  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])

  return (
    <>

        <DataTable
          objectName="Color"
          apiRoute={API_ROUTES.InventoryColors}
          // filteringProps={filteringProps}
          // sortingProps={sortingProps}
          addCustom={() => createModalSet(true)}
          edit editCustom={edit}
          delete={hasRole("DeleteCategories")} deleteCustom={deleteColor}
          refresh={refresh}>

          <DataTableField title="Name">
            <NameItem />
          </DataTableField>

          <DataTableField title="HEX Code" dataValueName="hexCode">
          </DataTableField>

          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

          <DataTableField title="Modified">
            <ModifiedItem />
          </DataTableField>

        </DataTable>



      {
        createModal &&
        <DrawerForm id="modal-add-color"
          title="Create Color"
          buttonText="Add Color"
          focusOn="add-color-name"
          onClose={() => createModalSet(false)}
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "modal-add-color", true);
              if (callback) callback();
              return;
            }

            hub.Post(API_ROUTES.InventoryColors, body, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Color has been added successfully!");
              }
              if (callback) callback(res);
            })

          }}>
          <div>

            <TextBox id="add-color-name" name="name" label="Name" marginBottom={5}
              labelUp block placeholder="E.g. Red, Blue, Green..." />

            <TextBox id="add-color-hex" name="hexcode" label="Color" marginBottom={5}
              value={selectedColor?.toUpperCase()} labelUp block
              icon="circle" iconType="solid" iconSize={22} maxLength={7}
              iconColor={selectedColor} iconStart placeholder="#000000"
              onTextChanges={e => {
                var txt = e;
                if (!txt.startsWith("#")) txt = "#" + e;
                selectedColorSet(txt);
              }} />

            <HexColorPicker color={selectedColor}
              onChange={e => selectedColorSet(e)} />

          </div>
        </DrawerForm>
      }


      {
        editModal && selectedItem &&
        <DrawerForm id="modal-edit-color"
          title="Edit Color"
          buttonText="Update Color"
          focusOn="edit-color-name"
          onClose={() => {
            editModalSet(false);
            selectedItemSet(undefined);
          }}
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "modal-edit-color", true);
              if (callback) callback();
              return;
            }

            hub.Put(API_ROUTES.InventoryColors, {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Color has been updated successfully!");
              }
              if (callback) callback(res);
            })

          }}>


          <TextBox id="edit-color-name" name="name" label="Name" marginBottom={5}
            value={selectedItem.name} labelUp block />

          <TextBox id="edit-color-hex" name="hexcode" label="Color" marginBottom={5}
            value={selectedColor?.toUpperCase()} labelUp block
            icon="circle" iconType="solid" iconSize={22} maxLength={7}
            iconColor={selectedColor} iconStart
            onTextChanges={e => {
              var txt = e;
              if (!txt.startsWith("#")) txt = "#" + e;
              selectedColorSet(txt);
            }} />

          <HexColorPicker color={selectedColor}
            onChange={e => selectedColorSet(e)} />


        </DrawerForm>
      }


      {
        deleteModal && selectedItem &&
        <Modal id="modal-delete-color"
          title="Delete Color"
          buttonText="Confirm & Delete"
          buttonColor="danger"
          onOpen={() => {
            // hub.Post(API_ROUTES.InventoryCategories + "verifydelete", {
            //   id: selectedItem.id
            // }, res => deleteResSet(res.data))
          }}
          onClose={() => {
            deleteModalSet(false)
            deleteResSet(undefined)
            selectedItemSet(undefined)
          }}
          onSubmit={deleteRes ? (body, callback) => {

            hub.Post(API_ROUTES.InventoryColors + "delete", {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Color has been deleted successfully!");
              }
              if (callback) callback(res);
            })

          } : undefined}
          staticBackdrop open visible>
          <div>
            <div className="mb-2">
              Are you sure you want to delete the color?
            </div>
            <div className="alert alert-danger">
              <FlexRow>
                <div style={{
                  width: 20,
                  height: 20,
                  backgroundColor: selectedItem.hexCode,
                  border: "1px solid #000",
                  borderRadius: 10
                }}>
                </div>
                <div className="ms-2">
                  {selectedItem.name}
                </div>
              </FlexRow>
            </div>

          </div>
        </Modal>
      }


    </>
  );
}
